import { Room } from '@spike/room-model';
import styles from './RoomCoverPhoto.module.scss';
import { FunctionComponent } from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-regular-svg-icons/faImage';

interface RoomCoverPhotoProps {
    room: Room;
    className?: string;
}

export const RoomCoverPhoto: FunctionComponent<RoomCoverPhotoProps> = props => {
    const existCoverPhoto = props.room.photos.length > 0;

    return (
        <div className={clsx(styles.container, { [styles.empty]: !existCoverPhoto }, props.className)}>
            {existCoverPhoto ? (
                <img
                    src={props.room.photos[0].url}
                    className={styles.image}
                />
            ) : (
                <FontAwesomeIcon
                    icon={faImage}
                    color="#d3d3d3"
                    fontSize={20}
                />
            )}
        </div>
    );
};

export default RoomCoverPhoto;
